import axios from "axios";

const baseInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
});

const WHITELISTED_ROUTES = [
  "/api/users/check-email",
  "/api/blogs/public",
  "/api/blogs/public/*",
];

baseInstance.interceptors.request.use(
  async (config) => {
    const isWhitelisted = WHITELISTED_ROUTES.some((route) =>
      config.url?.startsWith(route)
    );

    if (!isWhitelisted && typeof window !== "undefined") {
      try {
        // Wait for Clerk to be fully loaded
        if (!window.Clerk?.loaded) {
          await new Promise((resolve) => {
            const checkLoaded = () => {
              if (window.Clerk?.loaded) {
                resolve();
              } else {
                setTimeout(checkLoaded, 50);
              }
            };
            checkLoaded();
          });
        }

        const session = window.Clerk.session;
        if (!session) {
          throw new Error("No active session");
        }

        // Check if session is active before getting token
        if (!session.status === "active") {
          await session.reload();
        }

        const token = await session.getToken({
          template: process.env.NEXT_PUBLIC_CLERK_JWT_TEMPLATE,
        });
        if (!token) {
          throw new Error("No token available");
        }

        const isFormData = config.data instanceof FormData;

        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          ...(isFormData
            ? {} // Don't set Content-Type for FormData
            : { "Content-Type": "application/json" }),
        };
      } catch (error) {
        console.error("Token fetch error:", error);
        // Attempt to reload session on error
        await window.Clerk.session?.reload();
        throw error;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
baseInstance.interceptors.response.use(
  (response) => {
    // Ensure response data is properly structured
    if (response.data === undefined) {
      return Promise.reject(new Error("No response data"));
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401 && typeof window !== "undefined") {
      try {
        await window.Clerk.session?.reload();
      } catch (reloadError) {
        console.error("Session reload failed:", reloadError);
      }
    }
    return Promise.reject(error);
  }
);

export { baseInstance };
